import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP101_Request,
  IAPI_APP101_Response,
} from "../../../type/apiType";
import {
  IAPI_APP107_Request,
  IAPI_APP107_Response,
} from "../../../type/apiType";
import {
  IAPI_APP106_Request,
  IAPI_APP106_Response,
} from "../../../type/apiType";

// 要処理一覧参照API
// API仕様書_要処理対応
const httpAPI_APP101 = async (
  param: IAPI_APP101_Request
): Promise<IAPI_APP101_Response> => {
  let res = await http.post(ApiUrl.API_APP101, {
    ...param,
  });
  return res.data;
};

// グループ申請更新API
// API仕様書_要処理対応
const httpAPI_APP107 = async (
  param: IAPI_APP107_Request
): Promise<IAPI_APP107_Response> => {
  let res = await http.post(ApiUrl.API_APP107, {
    ...param,
  });
  return res.data;
};

// 要処理一覧　状況更新API
// API仕様書_要処理対応
const httpAPI_APP106 = async (
  param: IAPI_APP106_Request
): Promise<IAPI_APP106_Response> => {
  let res = await http.post(ApiUrl.API_APP106, {
    ...param,
  });
  return res.data;
};

export { httpAPI_APP101, httpAPI_APP107, httpAPI_APP106 };
